import { useState } from "react";
import { toaster } from "../ui/toaster";
import { Button, CloseButton, Dialog, Portal, Text, useDisclosure } from "@chakra-ui/react"

interface newUserProps {
    intent: "publish" | "archive"
    cb: Function,
}

export default function AnnouncementConfirmation(props: newUserProps) {

    const { onOpen, onClose } = useDisclosure();
    const [open, setOpen] = useState<boolean>(false);

    const handleConfirm = () => {
        props.cb()
        handleClose()

        toaster.create({
            title: props.intent === "publish" ? `Announcement has been published`: "Announcement has been archived",
            type: "success",
        })
    }

    const handleClose = () => {
        setOpen(false);
        onClose();
    }

    return (
        <Dialog.Root>
            <Dialog.Trigger asChild>
                <Button bg={"AbleBlue"} color={"white"} _hover={{ bg: "AbleYellow", color: "white" }}>{props.intent === "publish" ? "Publish Announcement" : "Archive Announcement"}</Button>
            </Dialog.Trigger>
            <Portal>
                <Dialog.Backdrop />
                <Dialog.Positioner>
                    <Dialog.Content>
                        <Dialog.Header>
                            {props.intent === "publish" && <Dialog.Title>Publish Announcement</Dialog.Title>}
                            {props.intent === "archive" && <Dialog.Title>Archive Announcement</Dialog.Title>}
                        </Dialog.Header>
                        <Dialog.Body>
                            {props.intent === "publish" &&<Text>This will cause the announcement to be published and cause notifications from the app. This action <strong>can not be undone</strong>. Are you sure you want to continue.</Text>}
                            {props.intent === "archive" &&<Text>This will remove the announcement from the app and add it to the archive. This action <strong>can not be undone</strong>. Are you sure you want to continue.</Text>}
                        </Dialog.Body>
                        <Dialog.Footer>
                            <Dialog.ActionTrigger asChild>
                                <Button variant="outline" bg={"AbleBlue"} _hover={{ bg: "AbleYellow", color: "white" }}>Cancel</Button>
                            </Dialog.ActionTrigger>
                            <Button bg={"AbleBlue"} color={"white"} _hover={{ bg: "AbleYellow", color: "white" }} onClick={handleConfirm}>{props.intent === "publish" ? "Publish" : "Archive"}</Button>
                        </Dialog.Footer>
                        <Dialog.CloseTrigger asChild>
                            <CloseButton size="sm" />
                        </Dialog.CloseTrigger>
                    </Dialog.Content>
                </Dialog.Positioner>
            </Portal>
        </Dialog.Root>
    )
}
